/**
 * Low-end / no-WebGL / prefers-reduced-motion fallback for "The Ascent"
 * (spec Page 8.4, mandatory). No <canvas>, no JS animation loop — a static
 * CSS approximation of the fully-assembled, ignited shard: a faceted spire
 * silhouette, cool near its base, warming to amber at the peak, with a soft
 * glow seated at the tip. Sits right-of-centre, matching where the WebGL
 * version's structure settles for the hero.
 *
 * TODO(assets): swap for a real rendered still of the ignited structure at
 * public/textures/ascent-fallback.webp (~1200x1600, <120KB) as a
 * `background-image` on the `.shard` div once that binary asset exists.
 */
export function StaticFallback() {
  return (
    <div aria-hidden="true" className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-white">
      <div
        className="shard absolute"
        style={{
          left: '62%',
          top: '18%',
          width: '22vw',
          minWidth: 220,
          maxWidth: 340,
          height: '58vh',
          clipPath: 'polygon(50% 0%, 78% 28%, 66% 100%, 34% 100%, 22% 28%)',
          background: 'linear-gradient(180deg, #FFC44D 0%, #FF8A3D 14%, #DCEFFF 42%, #C7D9EC 100%)',
          opacity: 0.9,
        }}
      />
      <div
        className="absolute rounded-full"
        style={{
          left: '62%',
          top: '16%',
          width: 180,
          height: 180,
          transform: 'translate(-50%, -50%)',
          background: 'radial-gradient(circle, rgba(255,138,61,0.55) 0%, rgba(255,138,61,0.15) 45%, transparent 72%)',
        }}
      />
    </div>
  );
}
